import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import {
    GET_FUNKPROTOKOLL_AKTUELLE_VERANSTALTUNGEN, GET_FUNKPROTOKOLL_AKTUELLE_VERANSTALTUNGEN_ERFOLGREICH, GET_FUNKPROTOKOLL_AKTUELLE_VERANSTALTUNGEN_FEHLER, GET_FUNKPROTOKOLL_BEENDETE_VERANSTALTUNGEN, GET_FUNKPROTOKOLL_BEENDETE_VERANSTALTUNGEN_ERFOLGREICH, GET_FUNKPROTOKOLL_BEENDETE_VERANSTALTUNGEN_FEHLER,
    GET_VERANSTALTUNG_BERECHTIGUNG_ERFOLGREICH,
    GET_VERANSTALTUNG_BERECHTIGUNG_FEHLER,
    GET_VERANSTALTUNGEN_AKTUELLE,
    GET_VERANSTALTUNGEN_AKTUELLE_ERFOLGREICH,
    GET_VERANSTALTUNGEN_AKTUELLE_FEHLER, GetFunkprotokollAktuelleVeranstaltungenAction, GetFunkprotokollAktuelleVeranstaltungenErfolgreichAction, GetFunkprotokollBeendeteVeranstaltungenErfolgreichAction,
    GetVeranstaltungBerechtigungErfolgreichAction,
    GetVeranstaltungenAktuelleAction,
    GetVeranstaltungenAktuelleErfolgreichAction,
    GetVeranstaltungenAktuelleFehlerAction
} from '../../../client-ngrx/veranstaltungen';
import {Veranstaltung, VeranstaltungBerechtigung} from '../../../clients/veranstaltungen';
import {
    AKTUELLE_VERANSTALTUNG_SETZEN,
    AktuelleVeranstaltungSetzenAction,
    PAGE_STATE_RESET,
    PageStateResetAction
} from './veranstaltung-auswaehlen.actions.ui';
import {DatenState} from '../app-state/daten.reducer';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    veranstaltungBerechtigung: VeranstaltungBerechtigung;

    veranstaltungenAktuelle: Array<Veranstaltung>;
    uiZeigeVeranstaltungenAktuelleLaden: boolean;
    uiZeigeVeranstaltungenAktuelleLadefehler: boolean;

    funkprotokollVeranstaltungenBeendet: Array<Veranstaltung>;
    funkprotokollVeranstaltungenBeendetLaden: boolean;
    funkprotokollVeranstaltungenBeendetFehler: boolean;

    aktuelleVeranstaltung: Veranstaltung;
}

export const initialPageState: PageState = {
    veranstaltungBerechtigung: null,

    veranstaltungenAktuelle: null,
    uiZeigeVeranstaltungenAktuelleLaden: false,
    uiZeigeVeranstaltungenAktuelleLadefehler: false,

    funkprotokollVeranstaltungenBeendet: null,
    funkprotokollVeranstaltungenBeendetLaden: false,
    funkprotokollVeranstaltungenBeendetFehler: false,

    aktuelleVeranstaltung: null
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // Page State Reset
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Page State Reset
        case PAGE_STATE_RESET: {
            const a = <PageStateResetAction> action;

            return Object.assign({}, state, <PageState> initialPageState);
        }

        case AKTUELLE_VERANSTALTUNG_SETZEN: {
            const a = <AktuelleVeranstaltungSetzenAction> action;

            if (a.payload != null) {
                return Object.assign({}, state, <PageState> {
                    aktuelleVeranstaltung: a.payload
                });
            } else {
                return state;
            }
        }

        // Veröffentlichte Veranstaltungen
        case GET_VERANSTALTUNGEN_AKTUELLE: {
            const a = <GetVeranstaltungenAktuelleAction> action;

            return Object.assign({}, state, <PageState> {
                uiZeigeVeranstaltungenAktuelleLaden: true
            });
        }

        case GET_VERANSTALTUNGEN_AKTUELLE_ERFOLGREICH: {
            const a = <GetVeranstaltungenAktuelleErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                veranstaltungenAktuelle: a.payload,
                uiZeigeVeranstaltungenAktuelleLaden: false,
                uiZeigeVeranstaltungenAktuelleLadefehler: false
            });
        }

        case GET_VERANSTALTUNGEN_AKTUELLE_FEHLER: {
            return Object.assign({}, state, <PageState> {
                veranstaltungenAktuelle: [],
                uiZeigeVeranstaltungenAktuelleLaden: false,
                uiZeigeVeranstaltungenAktuelleLadefehler: true
            });
        }

        // Funkprotokoll Veranstaltungen
        case GET_FUNKPROTOKOLL_AKTUELLE_VERANSTALTUNGEN: {
            const a = <GetFunkprotokollAktuelleVeranstaltungenAction> action;

            return Object.assign({}, state, <PageState> {
                uiZeigeVeranstaltungenAktuelleLaden: true
            });
        }

        case GET_FUNKPROTOKOLL_AKTUELLE_VERANSTALTUNGEN_ERFOLGREICH: {
            const a = <GetFunkprotokollAktuelleVeranstaltungenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                veranstaltungenAktuelle: a.payload,
                uiZeigeVeranstaltungenAktuelleLaden: false,
                uiZeigeVeranstaltungenAktuelleLadefehler: false
            });
        }

        case GET_FUNKPROTOKOLL_AKTUELLE_VERANSTALTUNGEN_FEHLER: {
            return Object.assign({}, state, <PageState> {
                veranstaltungenAktuelle: [],
                uiZeigeVeranstaltungenAktuelleLaden: false,
                uiZeigeVeranstaltungenAktuelleLadefehler: true
            });
        }

        case GET_FUNKPROTOKOLL_BEENDETE_VERANSTALTUNGEN: {
            return Object.assign({}, state, <PageState> {
                funkprotokollVeranstaltungenBeendetLaden: true
            });
        }

        case GET_FUNKPROTOKOLL_BEENDETE_VERANSTALTUNGEN_ERFOLGREICH: {
            const a = <GetFunkprotokollBeendeteVeranstaltungenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                funkprotokollVeranstaltungenBeendet: a.payload,
                funkprotokollVeranstaltungenBeendetLaden: false,
                funkprotokollVeranstaltungenBeendetFehler: false
            });
        }

        case GET_FUNKPROTOKOLL_BEENDETE_VERANSTALTUNGEN_FEHLER: {
            return Object.assign({}, state, <PageState> {
                funkprotokollVeranstaltungenBeendet: [],
                funkprotokollVeranstaltungenBeendetLaden: false,
                funkprotokollVeranstaltungenBeendetFehler: true
            });
        }


        // Berechtigungen der Veranstaltung laden
        case GET_VERANSTALTUNG_BERECHTIGUNG_ERFOLGREICH: {
            const a = <GetVeranstaltungBerechtigungErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                veranstaltungBerechtigung: a.payload
            });
        }

        case GET_VERANSTALTUNG_BERECHTIGUNG_FEHLER: {
            // Wenn der Benutzer Offline ist, sollten seine schon geladenen Daten erhalten bleiben
            let veranstaltungBerechtigung = null;
            if (state.veranstaltungBerechtigung !== null) {
                veranstaltungBerechtigung = Object.assign({}, state.veranstaltungBerechtigung);
            } else {
                veranstaltungBerechtigung = <VeranstaltungBerechtigung>{
                    benutzer_ist_veranstaltungsleiter: false,
                    veranstaltung_id: state.aktuelleVeranstaltung.veranstaltung_id
                };
            }
            return Object.assign({}, state, <DatenState>{
                veranstaltungBerechtigung: veranstaltungBerechtigung,
                veranstaltungBerechtigungLaden: false,
                veranstaltungBerechtigungFehler: true
            });
        }







        default: {
            return state;
        }
    }
}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('VeranstaltungAuswaehlenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getVeranstaltungenAktuelle = createSelector(getPageState, (state: PageState) => state.veranstaltungenAktuelle);
export const getUiZeigeVeranstaltungenAktuelleLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeVeranstaltungenAktuelleLaden);
export const getUiZeigeVeranstaltungenAktuelleLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeVeranstaltungenAktuelleLadefehler);
export const getAktuelleVeranstaltung = createSelector(getPageState, (state: PageState) => state.aktuelleVeranstaltung);
export const getVeranstaltungBerechtigung = createSelector(getPageState, (state: PageState) => state.veranstaltungBerechtigung);

export const getFPVeranstaltungenBeendet = createSelector(getPageState, (state: PageState) => state.funkprotokollVeranstaltungenBeendet);
export const getFPVeranstaltungenBeendetLaden = createSelector(getPageState, (state: PageState) => state.funkprotokollVeranstaltungenBeendetLaden);
export const getFPVeranstaltungenBeendetFehler = createSelector(getPageState, (state: PageState) => state.funkprotokollVeranstaltungenBeendetFehler);





